module.exports = __webpack_public_path__ + "assets/img/36_572.a682ceef.jpg";